var React = require('react');

function Hospital (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 1.801l-.553.365L3 7.764V19c0 1.093.907 2 2 2h14c1.093 0 2-.907 2-2V7.764l-9-5.963zm0 2.398l7 4.639V19H5V8.838l7-4.639zM11 9v3H8v2h3v3h2v-3h3v-2h-3V9h-2z"}));
}

Hospital.defaultProps = {"viewBox":"0 0 24 24","xmlnsV":"https://vecta.io/nano"};

module.exports = Hospital;

Hospital.default = Hospital;
